import { memo } from 'react';
import { cn } from '@/lib/utils';
import type { IEmojiReactionPickerProps } from '@/@types/messages';

const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🔥', '👎'];

export const EmojiReactionPicker = memo(function EmojiReactionPicker({
  onSelect,
}: IEmojiReactionPickerProps) {
  return (
    <div className="flex items-center gap-1 p-1">
      {QUICK_REACTIONS.map(emoji => (
        <button
          key={emoji}
          type="button"
          onClick={() => onSelect(emoji)}
          className={cn(
            'flex items-center justify-center size-8 rounded-md text-lg',
            'hover:bg-accent hover:scale-110 transition-all',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
          )}
          aria-label={`React with ${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
});
